<template>
  <Card :disabled="!isAvailable" radio @click="$emit('input', event)">
    {{ event.startTime }} - {{ event.endTime }}
  </Card>
</template>

<script>
import Card from '../Core/Card'
export default {
  name: 'PassCalendarEvent',
  components: {
    Card
  },
  props: {
    event: Object
  },
  computed: {
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    },
    isAvailable () {
      const reservation = this.event.reservations.find(reservation => {
        return parseInt(reservation.uid) === parseInt(this.selectedUser.uid)
      })
      if (reservation) {
        return false
      }
      return this.event.availability > 0
    }
  }
}
</script>
